<template lang="pug">
  section.riders#riders(v-lazyload)
    .container
      RidersTitle
      template(v-if="items.length")
        RidersFilter
        RidersSlider
      template(v-else)
        RidersPreloader
</template>

<script>
import { mapState, mapActions } from 'vuex'
import inViewport from '@/helpers/inViewport'

import RidersTitle from '@/components/riders/RidersTitle'
import RidersFilter from '@/components/riders/RidersFilter'
import RidersSlider from '@/components/riders/RidersSlider'
import RidersPreloader from '@/components/riders/RidersPreloader'
import RidersModal from '@/components/riders/RidersModal'

export default {
  name: 'Riders',
  components: {
    RidersModal,
    RidersPreloader,
    RidersSlider,
    RidersFilter,
    RidersTitle
  },
  computed: {
    ...mapState('riders', ['items']),
    ...mapState('siteVersions', {
      currentCountry: state => state.item
    })
  },
  watch: {
    currentCountry () {
      this.$nextTick(() => {
        inViewport(this.$el, this.fetch, 'offset')
      })
    }
  },
  methods: {
    ...mapActions('riders', ['fetch'])
  }
}
</script>
